// extracted by mini-css-extract-plugin
export default {"fake-button":"_3CoQX","fakeButton":"_3CoQX"};